import React, {  useState} from 'react';
import Layout from './components/layout/layout';
import Footer from './components/layout/footer';


function App(props:any) {




  const [globalStateReactive,setglobalStateReactive] = useState<any>({selected:'home',globalState:{todo:'pristine'}});
 

  return (
    <React.Fragment>
      <Layout state = {globalStateReactive} stateChanger ={setglobalStateReactive} />
      <Footer state = {globalStateReactive} stateChanger ={setglobalStateReactive}/>
    </React.Fragment>
  );
}

export default App;
